import { useNavigate, useParams } from "react-router-dom";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useIncidents from "../../common/hooks/pages/useIncidents";
import IncidentUpdateForm from "../components/IncidentUpdateForm";
import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import { useEffect } from "react";

function IncidentUpdate() {
  const navigate = useNavigate();

  const { id } = useParams();

  const { updateIncident, getIncident } = useIncidents();

  const { toast } = usePopup();

  const { mutate: updateIncidentMutate, isLoading: isCreating } = useMutation({
    mutationFn: updateIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const {
    data,
    mutate: getIncidentMutate,
    isLoading: isGetting,
  } = useMutation({
    mutationFn: getIncident,

    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting Incident!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (id) {
      getIncidentMutate(id);
    }
  }, []);

  const { incident } = data?.data || {};
  return (
    <BaseContainerWrapper>
      <IncidentUpdateForm
        onSubmit={(data) => updateIncidentMutate(data)}
        isSubmitting={isCreating}
        incident={incident}
        id={id}
      />
    </BaseContainerWrapper>
  );
}

export default IncidentUpdate;
